import { useCallback } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import {useModalState} from "./useModalState.ts";
import {config} from "../config.ts";

const timeout = config.inactivityTimeout
const promptBeforeIdle =  config.promptBeforeIdleTimeout


const useSessionTimeout = (logout: () => void) => {
    const [isOpenLogOut, openLogOutModal, closeLogOutModal] = useModalState(false);

    const onIdle = useCallback(() => {
        logout();
    }, [logout]);

    const onPrompt = useCallback(() => {
        openLogOutModal();
    }, [openLogOutModal]);

    const { reset } = useIdleTimer({
        onIdle,
        onPrompt,
        timeout,
        promptBeforeIdle,
        throttle: 500,
    });

    const onResetSession = useCallback(() => {
        reset();
        closeLogOutModal();
    }, [reset, closeLogOutModal]);

    return {
        isOpenLogOut,
        onResetSession,
    };
};

export default useSessionTimeout;